import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Link from '@mui/material/Link';

import BookingLink from 'components/Hotel/BookingLink.tsx';
import Welcome from 'components/Welcome.tsx';

import skyClub from 'gallery/skyclub.jpg';
import HoneyfundLink from 'components/Registry/HoneyfundLink';
import WilliamsSonomaLink from 'components/Registry/WilliamsSonomaLink';

const textStyle = {
  fontFamily: '"Waterfall", serif',
  color: 'text.secondary',
}
const textStyle2 = {
  fontFamily: '"Tangerine", serif',
  color: 'text.secondary',
}

const linkUnderline: 'none' | 'hover' | 'always' = "hover";

 export default function Intro() {
  return (
    <Box sx={{
      py: 3,
      px: {xs: 0, md: 3},
      alignSelf:"center",
      alignContent: "center",
      alignItems: "center",
      justifyContent: "center",
      display: 'flex',
      flexDirection: "column"
    }}>
      <Card sx={{ 
          maxWidth: 900,
          maxHeight: 950,
          width: "100%",
          // backgroundColor: "#1b1b19",
          backgroundColor: "#ffeedd",
          display: 'flex',
          flexDirection: {xs: "column", md: "row"}
        }}>
        <CardMedia
          sx={{ 
            height: "500px",
            objectFit: "contain",
          }}
          component="img"
          image={skyClub}
          title="Join us for a toast!"
        />
        <Box sx={{ width: "100%", display: "flex", flexDirection: "column"}}>
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              May 10, 2025
            </Typography>
            <Typography gutterBottom variant="h6" component="div">
              Update:
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              A number of people asking for our registry were unaware of the registry at Williams Sonoma stores in addition to the Honeyfund registry - apologies for any confusion
              <ul>
                <li>View our <HoneyfundLink /> and <WilliamsSonomaLink /></li>
              </ul>
              
            </Typography>
            <Typography gutterBottom variant="h2" sx={textStyle} component="div">
              Save the Date
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Please join us at the Museum of Science's Washburn Pavilion
              <ul>
                <li><Link href="/about" underline={linkUnderline}>Learn about our story</Link></li>
                <li><Link href="/details" underline={linkUnderline}> See the timeline of events!</Link></li>
                <li><Link href="/venue" underline={linkUnderline}>Check out the venue</Link></li>
                <li><Link href="/hotels" underline={linkUnderline}> Info about accomodations</Link></li>
                <li><BookingLink linkText='Book our recommended hotel with our discounted rate!' underline={linkUnderline}/></li>
              </ul>
            </Typography>
          </CardContent>
        </Box>
      </Card>
      <Welcome/>
    </Box>
  );
}
